module.exports = __webpack_public_path__ + "static/media/026.c1a06646.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/products/thumbs/026.jpg
// module id = 533
// module chunks = 0